module.exports = __webpack_public_path__ + "static/media/eye-evil.33e77155.svg";